import { Page } from '@/components/page';

export function Dashboard() {
  return <Page title="Dashboard" />;
}
